/**
 * Search Field Component
 * Text input with search icon for FP search
 */

import React from 'react'
import { TextField, Typography, Box } from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  autoFocus?: boolean
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder = 'Search by name or FP code',
  label = 'Search for Franchise Partners',
  autoFocus = false,
}) => {
  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={autoFocus}
        InputProps={{
          startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
        }}
      />
    </Box>
  )
}

export default SearchField
